import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const validSubDomains = ['collus', 'melrosepublicutilities', 'wmuc', 'qa-melrosepublicutilities', 'qa-wmuc', 'qa-enerconnect', 'enerconnect',
                                'qa-essexpowerlines', 'essexpowerlines', 'qa-dlpu', 'dlpu', 'qa-saukcentrepublicutilities', 'saukcentrepublicutilities',
                                'qa-worthingtonutilities', 'worthingtonutilities', 'vermillionlightandpower', 'qa-vermillionlightandpower',
                                'qa-wmu', 'wmu', 'qa-cityofpierreutilities', 'cityofpierreutilities', 'qa-beresfordutilities', 'beresfordutilities',
                                'qa-brookingsutilities', 'brookingsutilities', 'ecdemo', 'qa-ecdemo'];
export const permanentSubDomains = ['dev-ucauth', 'dev-ucauth-app', 'prod-ucauth-app', 'ucauth', 'localhost', 'utilismart'];
export const rootSubDomains = ['localhost'];
export const utilismartSubDomains = ['qa-smartmap', 'smartmap', 'mecl-meridio', 'qa-mecl-meridio', 'mecl-smartmap', 'mecl-beta-smartmap', 'mecl-uat-smartmap', 'mecl-qa-smartmap',
                                    'uat-udm', 'udm', 'mecl-udm', 'qa-mecl-udm', 'uat-mecl-udm', 'beta-smartmap', 'uat-smartmap', 'qa-smartmap', 'qa-sm', 'sm', 'qa-ciem', 'ciem', 'maritime-sm', 
                                    'maritime-ciem', 'healthmap', 'uat-healthmap', 'essexpower-sm', 'essexpower-ciem', 'burlingtonhydro-sm', 'burlingtonhydro-ciem',
                                    'ckenergy-sm', 'ckenergy-ciem', 'cnpower-sm', 'cnpower-ciem', 'comed-sm', 'comed-ciem', 'coresolutions-sm', 'coresolutions-ciem',
                                    'cpau-sm', 'cpau-ciem', 'emera-sm', 'emera-ciem', 'enersource-sm', 'enersource-ciem', 'entegrus-sm', 'entegrus-ciem',
                                    'enwin-sm', 'enwin-ciem', 'ets-sm', 'ets-ciem', 'jps-sm', 'jps-ciem', 'lunenburgnetwork-sm', 'lunenburgnetwork-ciem',
                                    'milton-sm', 'milton-ciem', 'npei-sm', 'npei-ciem', 'nsdemo-sm', 'nsdemo-ciem', 'oshawapuc-sm', 'oshawapuc-ciem',
                                    'rodan-sm', 'rodan-ciem', 'sttenergy-sm', 'sttenergy-ciem', 'tillsonburghydro-sm', 'tillsonburghydro-ciem',
                                    'utilismartcorp-sm', 'utilismartcorp-ciem', 'vip-sm', 'vip-ciem', 'wattsworth-sm', 'wattsworth-ciem', 'wilsonblanchard-sm', 'wilsonblanchard-ciem'];

// Maps subdomains to shared theme names when subdomain and file names differ
export const sharedThemeOverridesBySubdomain = {
    'mecl-smartmap': 'mecl',
    'mecl-beta-smartmap': 'mecl',
    'mecl-uat-smartmap': 'mecl',
    'mecl-qa-smartmap': 'mecl',
    'mecl-udm': 'mecl',
    'qa-mecl-udm': 'mecl',
    'uat-mecl-udm': 'mecl',
    'maritime-sm': 'mecl',
    'maritime-ciem': 'mecl',
    'healthmap': 'smartmap'
};

export const getDomainObj = () => {
    const decodedUri = decodeURIComponent(window.location.search);
    let actualSubDomain = window.location.host.split('.')[0].toLowerCase();
    let subDomainQuery = new URLSearchParams(decodedUri).get('subdomain') || "";
    let isQueryParam = false;

    if (subDomainQuery) {
        actualSubDomain = subDomainQuery.toLowerCase();
        isQueryParam = true;
    }

    // only use valid subdomains... the root domains do not need an actualSubDomain
    if (!validSubDomains.includes(actualSubDomain) && !utilismartSubDomains.includes(actualSubDomain)) {
        actualSubDomain = '';
    }

    const subDomain = actualSubDomain;
    const normalizedSubDomain = subDomain.replace("qa-", "").replace("uat-", "").replace("beta-", "");

    let returnUrl = new URLSearchParams(decodedUri).get('ReturnUrl') || "";
    returnUrl = decodeURI(returnUrl);
    let redirectUri = new URLSearchParams(returnUrl).get('redirect_uri') || "";
    redirectUri = decodeURI(redirectUri);
    let redirectSubDomain = redirectUri.replace("https://", "").replace("http://", "").split(".")[0].toLowerCase();

    if (validSubDomains.indexOf(redirectSubDomain) === -1) {
        redirectSubDomain = "";
    }

    console.log("SUBDOMAIN: " + subDomain)

    const baseUrlEnerConnect = subDomain && !utilismartSubDomains.includes(subDomain) ?
        (process.env.REACT_APP_EC_URL ?? '').replace("{subdomain}", subDomain + ".") :
        (process.env.REACT_APP_UCAUTH_BASE_PROTO + process.env.REACT_APP_UCAUTH_BASE_HOST);

    let domain = {
        theme: 'default',
        baseUrlEnerConnect: baseUrlEnerConnect,
        redirectSubDomain: redirectSubDomain,
        isQueryParam: false,
        defaultUrlUDM: process.env.REACT_APP_DEFAULT_UDM,
        defaultUrlSmartMAP: process.env.REACT_APP_DEFAULT_SMARTMAP,
        defaultUrlHealthMAP: process.env.REACT_APP_DEFAULT_HEALTHMAP,
        defaultUrlSM: process.env.REACT_APP_DEFAULT_SM,
        defaultUrlCIEM: process.env.REACT_APP_DEFAULT_CIEM
    }

    if (validSubDomains.includes(subDomain) && !permanentSubDomains.includes(subDomain)) {
        domain.subDomain = subDomain;
        domain.actualSubDomain = actualSubDomain;
        domain.theme = normalizedSubDomain;
        domain.isQueryParam = isQueryParam;
    }

    // Handle utilismartSubDomains themes via mapping
    if (utilismartSubDomains.includes(subDomain)) {
        domain.subDomain = subDomain;
        domain.actualSubDomain = actualSubDomain;
        domain.theme = sharedThemeOverridesBySubdomain[subDomain] || normalizedSubDomain;
        domain.isQueryParam = isQueryParam;
    }

    return domain;
};

export const domain = getDomainObj();

const appendDomainToUrl = (fullUrl) => {
    let url = new URL(fullUrl);

    const searchParams = new URLSearchParams(url.search);
    if (domain.isQueryParam) {
        searchParams.set('subdomain', domain.subDomain);
    }

    let queryString = searchParams.toString();
    if (queryString) {
        queryString = "?" + queryString;
    }

    const newUrl = new URL(`${url.origin}${url.pathname}${queryString}`);

    return newUrl.href;
};

export const getUrl = (relativeUrl) => {
    let url = new URL("https://replace.com" + relativeUrl);
    if (relativeUrl.startsWith("https://") || relativeUrl.startsWith("http://")) {
        // We have a full url could be a non-relative url at this point
        // UcAuth can get outside urls passed in
        url = new URL(relativeUrl);
    }

    const newUrl = appendDomainToUrl(url);

    return newUrl.replace("https://replace.com", "");
};

export const getFullUrl = (relativeUrl) => {
    let url = new URL(domain.redirectBaseUrl + relativeUrl);
    if (relativeUrl.startsWith("https://") || relativeUrl.startsWith("http://")) {
        // We have a full url could be a non-relative url at this point
        // UcAuth can get outside urls passed in
        url = new URL(relativeUrl);
    }

    return appendDomainToUrl(url);
};

export const useDomainNavigate = () => {
    let navigate = useNavigate();
    const [newNavigate] = useState({
        navigate: (to) => {
            const parsed = parseInt(to);
            if (!isNaN(parsed)) {
                // We have a number so just pass the number on
                navigate(parsed);
                return;
            }
            navigate(getUrl(to));
        }
    });

    return newNavigate.navigate;
};

export const redirectDomain = (newDomain) => {
    // split by . and :
    let actualSubDomain = window.location.host.split(/[.:]/)[0].toLowerCase();
    let searchParams = new URLSearchParams(window.location.search);

    if (permanentSubDomains.includes(actualSubDomain) || searchParams.has('subdomain')) {
        // permanentSubDomains can not change subdomain so we have to use querystring alternate
        // Also, if we started down the subdomain querystring path then we should always use subdomain
        searchParams.set("subdomain", newDomain.toLowerCase());
        window.location.search = searchParams.toString();
    }
    else if (rootSubDomains.includes(actualSubDomain)) {
        window.location.host = `${newDomain}.${window.location.host}`
    }
    else {
        window.location.host = window.location.host.replace(actualSubDomain, newDomain);
    }
};